import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v20l4-4h16V2zm-9 9h-2V5h2v6zm0 4h-2v-2h2v2z"
}), 'AnnouncementSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AnnouncementSharp.js
// module id = 2050
// module chunks = 2